import JobConfigurationPage from '@/pages/jobs/configuration'
import { WorkspacePortalProvider } from '@/contexts/workspace-portal-context'

export default function EventConfigurationPage() {
  return (
    <WorkspacePortalProvider mode="event">
      <JobConfigurationPage />
    </WorkspacePortalProvider>
  )
}
